module.exports = __webpack_public_path__ + "img/all-systems-red.3ea2985b.png";